import React, { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import { SearchContext } from "./Contexts/Context";

import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import pdf from "../images/collection-pdf.png";
import { FaLink } from "react-icons/fa";
import { getCard } from "../service/service";
function MeriaSamartlebriviAqtebi() {
  const { language } = useContext(SearchContext);
  const { search } = useContext(SearchContext);
  const [actebiList, setActebiList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [news, setNews] = useState({});
  useEffect(() => {
    const link = `https://khulo.gov.ge/api/legal_acts.php`;
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data)
        setNews(data);
        // console.log(data)
        // console.log('news', news)

        // console.log('object keys menu', Object.keys(menu))
        // console.log('object entries აქტები', Object.entries(data).map((item,index)=> console.log(item,index)))
      });
    // console.log('news', news)
    // console.log('news 0', news[0])
  }, []);

  const actebi = async () => {
    const res = await getCard("legal-acts").then((res) => {
      setActebiList(res.results);
      setLoading(true);
    });
  };

  useEffect(() => {
    actebi();
  }, []);

  const ActebiViev = () => {
    return actebiList?.map((item, index) => (
      <div className="" key={index}>
        <a href={`${item.url}`} target="blank">
          <span>{item.title}</span>

          <FaLink
            color="#04243F"
            style={{
              fontSize: "25px",
              marginLeft: "10px",
              borderLeft: "1px solid #BCBCBC",
              padding: "20px 25px",
              minWidth: "80px",
              minHeight: "70px",
            }}
          />
        </a>
      </div>
    ));
  };

  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="sakrebulo-landing">
        <div className="landing-container">
          <div className="sajaroInfo margin-280px">
            <header>
              {language == 1 ? "სამართლებრივი აქტები " : "LEGAL ACTS"}
            </header>
            <Helmet>
              <title>
                {language == 1 ? "სამართლებრივი აქტები " : "LEGAL ACTS"}
              </title>
            </Helmet>
            {loading ? <ActebiViev /> : <div>Loading...</div>}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default MeriaSamartlebriviAqtebi;
